// API helper with automatic token handling for mobile support

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Fetch wrapper that automatically includes session token from localStorage
 * as a fallback when cookies don't work (e.g., on some mobile browsers)
 */
export async function apiFetch(endpoint, options = {}) {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  
  // Get token from localStorage
  const token = localStorage.getItem("session_token");
  
  // Merge headers
  const headers = {
    ...options.headers,
  };
  
  // Add Authorization header if token exists
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  
  // Always include credentials for cookie support
  // NB: rimossi 'credentials: "include"' perché il backend risponde con CORS Allow-Origin: *
  // (combinazione INVALIDA con Allow-Credentials: true) → iOS Safari blocca rigidamente.
  // Bearer token da localStorage è sufficiente per l'autenticazione.
  const fetchOptions = {
    ...options,
    headers,
  };
  
  const response = await fetch(url, fetchOptions);
  
  // If unauthorized, clear the token
  if (response.status === 401) {
    localStorage.removeItem("session_token");
  }
  
  return response;
}

/**
 * Convenience methods
 */
export const api = {
  get: (endpoint, options = {}) => apiFetch(endpoint, { ...options, method: 'GET' }),
  
  post: (endpoint, data, options = {}) => apiFetch(endpoint, {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    body: JSON.stringify(data),
  }),
  
  patch: (endpoint, data, options = {}) => apiFetch(endpoint, {
    ...options,
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    body: data ? JSON.stringify(data) : undefined,
  }),
  
  delete: (endpoint, options = {}) => apiFetch(endpoint, { ...options, method: 'DELETE' }),
};

export default api;
